import styled from 'styled-components'
import {
  communicationButtonCss,
  communicationContentWrapperCss,
  communicationRootCss,
  communicationTitleCss,
} from '~/pages/communication/libs/communicationBaseStyles'

export const RoleModelCommunicationStyles = {
  Root: styled.div`
    ${communicationRootCss}
  `,

  ContentWrapper: styled.div`
    ${communicationContentWrapperCss}
  `,

  Title: styled.h1`
    ${communicationTitleCss}
  `,

  Subtitle: styled.p`
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
    text-align: center;
    color: #6b7280;
    margin-top: -8px;
  `,

  AvatarGrid: styled.div`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 16px;
    width: 100%;
    align-content: space-between;
    margin: auto 0;
  `,

  AvatarItem: styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  `,

  AvatarCircle: styled.button<{ $isSelected: boolean }>`
    width: 104px;
    height: 104px;
    border-radius: 50%;
    border: 2px solid
      ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#eaeaed')};
    overflow: hidden;
    background: ${({ $isSelected }) => ($isSelected ? '#096ef9' : '#fff')};
    padding: 0;
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    touch-action: manipulation;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }
  `,

  AvatarName: styled.span`
    font-size: 12px;
    font-weight: 400;
    line-height: 1.3;
    text-align: center;
    color: #374151;
  `,

  Button: styled.button`
    ${communicationButtonCss}
  `,
}
